import React, { useEffect, useState } from 'react';
import Styles from "./Chatbot.module.scss";

const LoadingText = ({text = 'Loading'}) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => (prev.length < 3 ? prev + '.' : ''));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return <span className={`${Styles.loadingText}`}>{text}{dots}</span>;
};

export default LoadingText;
